export type MapBounds = [
  west: number,
  south: number,
  east: number,
  north: number,
];

export function isInBounds(
  longitude: number,
  latitude: number,
  bounds: MapBounds | undefined | null
): boolean {
  if (!bounds) {
    return true;
  }

  const [west, south, east, north] = bounds;

  return (
    longitude >= west &&
    longitude <= east &&
    latitude >= south &&
    latitude <= north
  );
}
